/* unplugin-vue-components disabled */import script from "./user-project-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./user-project-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./user-project-dialog.vue?vue&type=style&index=0&id=5897bbfc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5897bbfc"]])

export default __exports__